import { useCallback } from 'react';
import { useNotificationActions } from 'src/store';
import {
  isBackendError,
  isValidationError,
  isChannelAuthError,
  isAsyncRequestError,
} from 'src/lib/errors';
import { captureException } from 'src/utils/lib/sentry';

const shouldDisplayAsWarning = (error) => isValidationError(error);

const shouldDisplayAsIs = (error) =>
  error?.networkError ||
  error?.graphQLErrors ||
  isBackendError(error) ||
  isChannelAuthError(error) ||
  isAsyncRequestError(error);

export const useErrorHandler = () => {
  const notificationActions = useNotificationActions();

  return useCallback(
    (error, extra) => {
      if (shouldDisplayAsWarning(error) && error.message) {
        notificationActions.displayWarning(error.message);
      } else if (shouldDisplayAsIs(error) && error.message) {
        notificationActions.displayError(error);
      } else {
        notificationActions.displayError(
          new Error('Sorry, something went wrong. We’re working on it.')
        );

        captureException(error, {
          extra: {
            source: 'useErrorHandler',
            ...extra,
          },
        });
      }
    },
    [notificationActions]
  );
};
